var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"rating"},[_c('img',{attrs:{"src":_vm.image,"alt":"rating","loading":_vm.loading}}),_c('p',[_vm._v(_vm._s(_vm.$t('qic_landing_rating_desc')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }